import { render } from "./Budget.vue?vue&type=template&id=567ba1dc&scoped=true&bindings={\"view\":\"props\",\"homeValue\":\"data\",\"kitchenPercent\":\"data\",\"kitchenItems\":\"data\",\"bathroomPercent\":\"data\",\"bathroomItems\":\"data\",\"kitchenBudget\":\"options\",\"kitchenTotal\":\"options\",\"bathroomBudget\":\"options\",\"bathroomTotal\":\"options\"}"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-567ba1dc"

export default script